import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AuthContext = /*#__PURE__*/createContext(null);
export const ProvideAuth = t0 => {
  const $ = _c(6);
  const {
    hasScope,
    hasGate,
    children
  } = t0;
  let t1;
  if ($[0] !== hasGate || $[1] !== hasScope) {
    t1 = {
      hasScope,
      hasGate
    };
    $[0] = hasGate;
    $[1] = hasScope;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const value = t1;
  let t2;
  if ($[3] !== children || $[4] !== value) {
    t2 = /*#__PURE__*/_jsx(AuthContext.Provider, {
      value: value,
      children: children
    });
    $[3] = children;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const useAuth = () => {
  return useContext(AuthContext);
};